import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { AuthState } from './index.type';
import { AUTH_STORAGE_KEY, createAuthStateStorage } from './auth-storage';

const initialState = {
  isAuthenticated: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  selectedOrgId: null,
  tokens: null,
  isOidcSession: false,
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      ...initialState,
      login: (accessToken, refreshToken) =>
        set((state) => ({
          ...state,
          isAuthenticated: true,
          accessToken,
          refreshToken,
        })),
      setAccessToken: (accessToken) =>
        set((state) => ({
          ...state,
          accessToken,
        })),
      setOidcSession: (isOidcSession) =>
        set((state) => ({
          ...state,
          isOidcSession,
        })),
      logout: () => set(initialState),
      setTokens: (tokens) =>
        set((state) => ({
          ...state,
          tokens,
          accessToken: tokens.accessToken,
          refreshToken: tokens.refreshToken,
        })),
      setSelectedOrgId: (selectedOrgId) =>
        set((state) => ({
          ...state,
          selectedOrgId,
        })),
      setUser: (user) =>
        set((state) => ({
          ...state,
          user,
        })),
      reset: () => set(initialState),
    }),
    {
      name: AUTH_STORAGE_KEY,
      storage: createJSONStorage(createAuthStateStorage),
      // `user` carries the permission set of the organization the token was issued for. Persisting it
      // means a reload (e.g. right after switching organization) starts on the previous organization's
      // permissions: the sidebar shows the wrong menu and `ProtectedRoute` can bounce the user off the
      // page they are on. The Guard rebuilds it from the live account + role permissions each load.
      // `selectedOrgId` is not persisted for the same reason: after a switch the stored one is the old
      // organization, so the Guard sets it again from `me` on every load before any page renders.
      partialize: ({ user: _user, selectedOrgId: _selectedOrgId, ...persisted }) => persisted,
    }
  )
);
